import clsx from 'clsx'
import React from 'react'

import {BackgroundColor, BorderRadiusVariants, PaddingVariants} from './types'
import {classes} from './UnstableCard.classes'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick'> & {
  className?: string
  footerClassName?: string
  footer?: JSX.Element
  bgColor?: BackgroundColor
  padding?: PaddingVariants
  radius?: BorderRadiusVariants
  noOverflow?: boolean
  onPress?: VoidFunction
}

export const UnstableCard: React.FC<Props> = ({
  children,
  className,
  footerClassName,
  footer,
  bgColor = 'main',
  padding = 'M',
  radius = 'M',
  noOverflow = false,
  onPress,
  ...rest
}) => {
  return (
    <div
      className={clsx(
        classes.root,
        {
          [classes[`root_${bgColor}`]]: true,
          [classes[`root_padding_${padding}`]]: true,
          [classes[`root_border_radius_${radius}`]]: true,
          [classes.noOverflow]: noOverflow,
        },
        className,
      )}
      onPointerUp={onPress}
      {...rest}
    >
      {children}
    </div>
  )
}
